export enum ScreenBrakepoints {
  MaxWidth428px,
  MaxWidth768px,
  MinWidth769px,
}